<template>
  <router-view />
</template>

<script>
export default {
  name: 'User.Configuration.Inbound'
}
</script>

<style scoped>

</style>
